import { http } from "./config";
import authHeader from "./auth-header";

export default {
  getAll() {
    return http.get("/api/tickets-vaso", {
      headers: authHeader(),
    });
  },

  getById(id) {
    return http.get(`/api/tickets-vaso/${id}`, {
      headers: authHeader(),
    });
  },

  update(id, ticketDTO) {
    return http.put(`/api/tickets-vaso/${id}`, ticketDTO, {
      headers: authHeader(),
    });
  },

  getByPeriodo(dataInicio, dataFim) {
    return http.get("/api/tickets-vaso/periodo", {
      headers: authHeader(),
      params: { dataInicio, dataFim },
    });
  },

  exportar_fluxo_vaso_xls(params = {}) {
    return http.get("/api/tickets-vaso/tickets-xls", {
      headers: authHeader(),
      params,
      responseType: "blob",
    });
  },

  getAllEtapas() {
    return http.get("/api/tickets-vaso/etapas", {
      headers: authHeader(),
    });
  },

  getAtividadesPorEtapa(etapaId) {
    return http.get(`/api/tickets-vaso/atividades/etapa/${etapaId}`, {
      headers: authHeader(),
    });
  },

  getAllEtapaAtividades() {
    return http.get("/api/tickets-vaso/etapa-atividades", {
      headers: authHeader(),
    });
  },

  getEtapaAtividadeById(id) {
    return http.get(`/api/tickets-vaso/etapa-atividades/${id}`, {
      headers: authHeader(),
    });
  },

  getEtapaAtividadesByTicketEtapaId(ticketVasoEtapaId) {
    return http.get(
      `/api/tickets-vaso/etapa-atividades/ticket-etapa/${ticketVasoEtapaId}`,
      { headers: authHeader() }
    );
  },

  createEtapaAtividade(dto) {
    return http.post("/api/tickets-vaso/etapa-atividades", dto, {
      headers: authHeader(),
    });
  },

  updateEtapaAtividade(id, dto) {
    return http.put(`/api/tickets-vaso/etapa-atividades/${id}`, dto, {
      headers: authHeader(),
    });
  },

  deleteEtapaAtividade(id) {
    return http.delete(`/api/tickets-vaso/etapa-atividades/${id}`, {
      headers: authHeader(),
    });
  },

  uploadAnexo(ticketId, file) {
    const formData = new FormData();
    formData.append("file", file);

    return http.post(`/api/tickets-vaso/${ticketId}/anexos`, formData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteAnexo(ticketId, anexoId) {
    return http.delete(`/api/tickets-vaso/${ticketId}/anexos/${anexoId}`, {
      headers: authHeader(),
    });
  },
};
